import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { HelperService } from "../../../services/helper.service";
import { DataSearchMultipleFiles } from "../../../models/util/claims";
import { ListsCovinocService } from "../../../services/lists-covinoc.service";

@Component({
  selector: "app-filter-claims",
  templateUrl: "./filter-claims.component.html",
  styleUrls: ["./filter-claims.component.scss"],
})
export class FilterClaimsComponent implements OnInit {
  @Output() getDataFilterCv = new EventEmitter<any>();
  @Output() getDataFilterFiles = new EventEmitter<any>();
  @Output() filterSelect = new EventEmitter<any>();
  dataGetFiles: DataSearchMultipleFiles = new DataSearchMultipleFiles();
  filterData = "1";
  docTypes: any;
  filter: string;
  cv: string;

  filtersOptions = [
    {
      id: "1",
      name: "Cargue Documentos",
    },
    // {
    //   id: "2",
    //   name: "Consulta por Documentos",
    // },
    // {
    //   id: "3",
    //   name: "Consulta por CV",
    // },
  ];

  constructor(
    private listCovinoc: ListsCovinocService,
    public helper: HelperService
  ) {}

  ngOnInit() {
    this.changeFilter(this.filterData);
    this.getDoccuments();
  }

  getDoccuments() {
    this.listCovinoc.findAllLists().subscribe((resp: any) => {
      this.docTypes = resp.data[0].documentTypesNew;
    });
  }

  searchCv() {
    this.getDataFilterCv.emit(this.cv);
  }

  searchDocuments() {
    this.getDataFilterFiles.emit(this.dataGetFiles);
  }

  changeValue(event: any) {
    this.filter = event;
    //this.filter = this.quotaVsAffiliateSearchForm.get('idPayer').value;
  }

  changeFilter(filter: any) {
    this.dataGetFiles = new DataSearchMultipleFiles();
    this.cv = "";
    this.filterSelect.emit(filter);
    //console.log(filter)
  }
}
